import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ItemVideoIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M12 0.25C5.52 0.25 0.25 5.52 0.25 12C0.25 18.48 5.52 23.75 12 23.75C18.48 23.75 23.75 18.48 23.75 12C23.75 5.52 18.48 0.25 12 0.25ZM12 22.25C6.35 22.25 1.75 17.65 1.75 12C1.75 6.35 6.35 1.75 12 1.75C17.65 1.75 22.25 6.35 22.25 12C22.25 17.65 17.65 22.25 12 22.25Z"
        fill={color}
      />
      <path
        d="M16.81 11.46L9.81001 7.45999C9.41001 7.21999 8.86001 7.53999 8.87001 7.99999V16C8.86001 16.46 9.41001 16.79 9.81001 16.54L16.81 12.54C17.22 12.32 17.22 11.67 16.81 11.46ZM10.12 14.92V9.06999L15.24 11.99L10.12 14.91V14.92Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ItemVideoIcon.displayName = 'ItemVideoIcon';
